import { createRoot } from "react-dom/client";
import App from "./App";

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{
    outcome: "accepted" | "dismissed";
    platform: string;
  }>;
}

declare global {
  interface Window {
    __deferredInstallPromptEvent?: BeforeInstallPromptEvent | null;
  }
}

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(<App />);

window.addEventListener("beforeinstallprompt", (event) => {
  event.preventDefault();
  window.__deferredInstallPromptEvent = event as BeforeInstallPromptEvent;
  window.dispatchEvent(new Event("pwa-installable"));
});

window.addEventListener("appinstalled", () => {
  window.__deferredInstallPromptEvent = null;
});

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    if (process.env.NODE_ENV === "production" && window.isSecureContext) {
      navigator.serviceWorker.register("/serviceWorker.js").catch(() => undefined);
      return;
    }

    if (process.env.NODE_ENV !== "production") {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => {
          registration.unregister();
        });
      });
    }
  });
}
